// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserMenu_wrapper__Bc362 {
  position: relative;
}

.UserMenu_optContainer__6rmne {
  position: absolute;
  top: 0;
  right: -2rem;
  z-index: 999;
  margin-top: 2rem;
  background-color: var(--white);
  border-radius: 6px;
  width: 16.25em;
  height: 14.55em;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
}

.UserMenu_optContainer__6rmne::after {
  content: '';
  position: absolute;
  left: 45%;
  bottom: 100%;
  width: 0;
  height: 0;
  border-left: 0.7rem solid transparent;
  border-right: 0.7rem solid transparent;
  border-bottom: 0.7rem solid var(--white);
}

.UserMenu_optContainer__6rmne:hover {
  cursor: pointer;
}

.UserMenu_listOptions__9kz7s {
  list-style: none;
  font-family: Inter;
  font-style: normal;
  font-weight: 300;
  font-size: 16.8px;
  letter-spacing: -0.01em;
}

.UserMenu_listOptions__9kz7s li {
  border-bottom: 1px solid var(--tooltip-line);
  margin: 2rem 2rem 1rem 0.2rem;
  padding-bottom: 1rem;
  width: 90%;
}

.UserMenu_listOptions__9kz7s li:last-child {
  color: var(--secondary-color);
  margin-bottom: 0px;
}

.UserMenu_listOptions__9kz7s li:hover {
  transform: scale(1.02);
}

.UserMenu_btnUserContainer__I0iJB {
  display: flex;
  cursor: pointer;
  width: auto;
  text-align: left;
}

.UserMenu_userContainer__VQUEk {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.UserMenu_userName__HkyDp {
  margin: 0rem 0rem -0.1rem 1rem;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  color: var(--bg-primary);
}

.UserMenu_userRole__cMHpZ {
  margin-left: 1rem;
  font-family: Inter;
  font-style: normal;
  font-weight: 300;
  font-size: 17px;
  line-height: 1.2rem;
  color: var(--form-btn-cancel);
}

.UserMenu_arrow__tb6U4 {
  margin: 0.5rem 0rem 0rem 0.8rem;
}

.UserMenu_btnUserContainer__I0iJB button {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}

@media only screen and (max-width: 1310px) {
  .UserMenu_btnUserContainer__I0iJB {
    margin-left: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/userMenu/UserMenu.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,6BAA6B;EAC7B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".wrapper {\r\n  position: relative;\r\n}\r\n\r\n.optContainer {\r\n  position: absolute;\r\n  top: 0;\r\n  right: -2rem;\r\n  z-index: 999;\r\n  margin-top: 2rem;\r\n  background-color: var(--white);\r\n  border-radius: 6px;\r\n  width: 16.25em;\r\n  height: 14.55em;\r\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.optContainer::after {\r\n  content: '';\r\n  position: absolute;\r\n  left: 45%;\r\n  bottom: 100%;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 0.7rem solid transparent;\r\n  border-right: 0.7rem solid transparent;\r\n  border-bottom: 0.7rem solid var(--white);\r\n}\r\n\r\n.optContainer:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.listOptions {\r\n  list-style: none;\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-size: 16.8px;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.listOptions li {\r\n  border-bottom: 1px solid var(--tooltip-line);\r\n  margin: 2rem 2rem 1rem 0.2rem;\r\n  padding-bottom: 1rem;\r\n  width: 90%;\r\n}\r\n\r\n.listOptions li:last-child {\r\n  color: var(--secondary-color);\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.listOptions li:hover {\r\n  transform: scale(1.02);\r\n}\r\n\r\n.btnUserContainer {\r\n  display: flex;\r\n  cursor: pointer;\r\n  width: auto;\r\n  text-align: left;\r\n}\r\n\r\n.userContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.userName {\r\n  margin: 0rem 0rem -0.1rem 1rem;\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 17px;\r\n  color: var(--bg-primary);\r\n}\r\n\r\n.userRole {\r\n  margin-left: 1rem;\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-size: 17px;\r\n  line-height: 1.2rem;\r\n  color: var(--form-btn-cancel);\r\n}\r\n\r\n.arrow {\r\n  margin: 0.5rem 0rem 0rem 0.8rem;\r\n}\r\n\r\n.btnUserContainer button {\r\n  width: 50px;\r\n  height: 50px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 100%;\r\n}\r\n\r\n@media only screen and (max-width: 1310px) {\r\n  .btnUserContainer {\r\n    margin-left: 2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `UserMenu_wrapper__Bc362`,
	"optContainer": `UserMenu_optContainer__6rmne`,
	"listOptions": `UserMenu_listOptions__9kz7s`,
	"btnUserContainer": `UserMenu_btnUserContainer__I0iJB`,
	"userContainer": `UserMenu_userContainer__VQUEk`,
	"userName": `UserMenu_userName__HkyDp`,
	"userRole": `UserMenu_userRole__cMHpZ`,
	"arrow": `UserMenu_arrow__tb6U4`
};
export default ___CSS_LOADER_EXPORT___;
